import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const New = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="New" {...props}>
    <path d="M11.9999 1C12.5522 1.00003 12.9999 1.44774 12.9999 2V10.1309L20.4452 5.16797C20.9047 4.86167 21.5256 4.98585 21.832 5.44531C22.1383 5.90482 22.0141 6.52567 21.5546 6.83203L13.8027 12L21.5546 17.168L21.6366 17.2285C22.028 17.5508 22.1192 18.1238 21.832 18.5547C21.5448 18.9854 20.9811 19.1217 20.5331 18.8848L20.4452 18.832L12.9999 13.8682V22C12.9999 22.5523 12.5522 23 11.9999 23C11.4477 22.9999 10.9999 22.5522 10.9999 22V13.8682L3.55461 18.832C3.0951 19.1383 2.47423 19.0142 2.16789 18.5547C1.86162 18.0952 1.98581 17.4743 2.44524 17.168L10.1972 12L2.44524 6.83203L2.3632 6.77148C1.97186 6.44922 1.88068 5.8762 2.16789 5.44531C2.45506 5.0146 3.01879 4.87829 3.46672 5.11523L3.55461 5.16797L10.9999 10.1309V2C10.9999 1.44776 11.4477 1.00008 11.9999 1Z" fill="#000" />
  </StyledIcon>
));

New.displayName = 'New';

export { New };
